import { MessageDescriptor } from 'react-intl';

/**
 * Safely converts MessageDescriptor objects to strings.
 * Handles cases where defineMessage objects were incorrectly stored as data.
 */
export function messageDescriptorToString(
    value: string | MessageDescriptor | null | undefined,
): string | null | undefined {
    if (!value) {
        return value as null | undefined;
    }

    if (typeof value === 'string') {
        return value;
    }

    if (typeof value === 'object' && 'defaultMessage' in value) {
        const defaultMessage = value.defaultMessage;
        // defaultMessage can be string or MessageFormatElement[], we only want strings
        return typeof defaultMessage === 'string' ? defaultMessage : undefined;
    }

    return undefined;
}
